
/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import axios from "axios";
import {pathConstants} from "@/shared/pathConstants";
import {helpers} from "@/shared/helper";
import Vue from "vue";

export const reglementaireService = {
    fetchReglementaires,
    downloadRegFile,
    fetchArticles,
    fetchArticleById
};

function fetchReglementaires() {
    return axios.get(`${pathConstants.API}/reglementaire`)
        .then(result => {
        return result.data;
        }, err => {
        Vue.$log.error("fetchReglementaires", err);
    });
}

function downloadRegFile(id) {
    return axios({
        url: pathConstants.API + `/reglementaire/download/${id}`,
        method: 'GET',
        responseType: 'blob',
        showLoader: false
    }).then((response) => {
        console.log(response);
        helpers.downloadFile(response);
    });
}

function fetchArticles(currentPage, perPage, sortBy = null, sortDir = null) {
    return axios
        .post(pathConstants.API + "/articles", {
            page: currentPage > 1 ? currentPage - 1 : 0,
            size: perPage,
            defaultSort: "creationDate",
            defaultOrder: false
        })
        .then(result => {
            return result.data;
        }, err => {
            Vue.$log.error("fetchArticles", err);
        });
}
function fetchArticleById(articleID){
    // console.log(articleID);
    // return axios
    //   .post(`${pathConstants.API}/article/${articleID}`)
    //   .then(result => {
    //       return result.data;
    //     }, err => {
    //       Vue.$log.error('fetchArticleById', err);
    //     }
    //   );
    return axios
        .post(pathConstants.API + "/article", {
            id_article : articleID
        })
        .then(result => {
            return result.data;
        }, err => {
            Vue.$log.error("fetchArticleById", err);
        });
  }